module.exports = __webpack_public_path__ + "static/media/vikings_go_berzerk.yggdrasil.7a4ba40e.jpeg";